import { useQuery } from "@tanstack/react-query";
import { useSearchParams } from "react-router-dom";

import { apiGet } from "../../api/client";
import type { FeedResponse } from "../../api/legacyTypes";
import { AppShell } from "../../app/AppShell";
import { TournamentCard } from "../../components/TournamentCard";
import { gameModule } from "../../games/registry";
import { sortTournamentsForCatalogue } from "../../utils/tournamentSort";

export function WatchlistPage() {
  const [params, setParams] = useSearchParams();
  const game = params.get("game") || "all";
  const query = useQuery({
    queryKey: ["feed"],
    queryFn: ({ signal }) => apiGet<FeedResponse>("/api/v1/feed", signal),
  });
  const tournaments = sortTournamentsForCatalogue(
    (query.data?.tournaments ?? []).filter((tournament) => game === "all" || tournament.wiki === game),
  );
  const changeGame = (nextGame: string) => {
    const next = new URLSearchParams(params);
    if (nextGame === "all") next.delete("game"); else next.set("game", nextGame);
    setParams(next);
  };

  return <AppShell selectedGame={game} onGameChange={changeGame}>
    <section className="page-heading">
      <p className="eyebrow">Followed tournaments</p>
      <h1>{game === "all" ? "Watchlist" : `${gameModule(game)?.name ?? "Game"} watchlist`}</h1>
      <p>Rich tournament cards with upcoming matches, quick results, manual refresh, and direct access to each event.</p>
    </section>
    {query.isPending && <p className="state-panel">Loading your tournament watchlist…</p>}
    {query.isError && <p className="state-panel state-error">The tournament watchlist could not be loaded.</p>}
    {!query.isPending && !query.isError && tournaments.length === 0 && <p className="state-panel">No followed tournaments for this game yet.</p>}
    <div className="feed-stack">{tournaments.map((tournament) => <TournamentCard key={tournament.id} tournament={tournament} />)}</div>
  </AppShell>;
}
